import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  container: {
    marginTop: 44,
    height: 'auto',
  },
  contactUsDetail: {
    marginTop: 45,
  },
  contactBox: {
    border: '1px solid',
    borderColor: '#BCBCBC',
    borderRadius: 10,
    opacity: 1,
    paddingTop: 10,
    paddingBottom: 10,
    paddingLeft: 22,
    color: '#464646',
    letterSpacing: 0,
    marginBottom: 24,
    '& a': {
      textDecoration: 'none',
      color: '#464646',
    },
  },
  contactBoxTitle: {
    fontSize: 18,
    fontWeight: 600,
  },
  contactBoxSubtitle: {
    fontSize: 16,
  },
  imgContainer: {
    margin: 'auto',
  },
});

export default useStyles;
